import type BookingServiceTypeEnum from 'owa-service/lib/contract/BookingServiceTypeEnum';

const mapBookingServiceTypeEnum = (
    serviceType: BookingServiceTypeEnum
): 'ExternalAvailability' | 'TimeOff' | 'UserDefined' => {
    switch (serviceType) {
        case 2:
            return 'ExternalAvailability';
        case 1:
            return 'TimeOff';
        case 0:
            return 'UserDefined';
    }
};

export default mapBookingServiceTypeEnum;
